module.exports = __webpack_public_path__ + "static/media/closeBtn.e7cf0f72.svg";